import { RadioTheme } from "@acin.reactjs/acin-ui/radio";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const radioTheme: ComponentCSSStyle<RadioTheme> = {
  formLabel: { asterisk: { readOnly: { root: { display: "none" } } } },
};

export default radioTheme;
